import { connect } from 'react-redux';
import { get } from 'lodash';
import View from './component';
import { setMessage } from './actions';

const mapStateToProps = (state) => ({
  message: get(state, 'notification.message'),
  duration: get(state, 'notification.duration'),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(setMessage({ message: null })),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
